<!-- 学员 -->
<template>
  <div>
    <!-- 检索栏 -->
    <div class="tab">
      <div class="control">
        <el-form ref="form" :model="form" label-width="120px" size="mini">
          <el-row>
            <el-col :span="12">
              <el-form-item prop="fullName" label="考生姓名：">
                <el-input v-model="form.fullName" placeholder="-请输入学生姓名-"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="userCard" label="考生身份证：">
                <el-input v-model="form.userCard" placeholder="-请输入学生身份证-"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button type="primary" size="mini" @click="search">确定</el-button>
        <el-button size="mini" @click="delAll"> 清空 </el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
    >
      <!-- <el-table-column type="selection" width="50" align="center">
      </el-table-column> -->
      <el-table-column width="50" prop="rowNum" label="ID" align="center"></el-table-column>
      <el-table-column
        prop="fullName"
        label="考生姓名"
        align="center"

      >
      </el-table-column>
      <el-table-column
        prop="uname"
        label="用户名"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="userCard"
        label="身份证号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="batchCode"
        :label="'批次号/\n 班级编码'"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="albumTitle"
        label="班级名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="rkTeacherName"
        label="任课老师"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="rkMhmName"
        label="任课机构"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="tourStatus"
        label="巡考状态"
        width="130"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="scoreStatus"
        label="巡考结果"
        width="130"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="openTime"
        label="考试开始时间"
        width="140"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="endTime"
        label="考试结束时间"
        width="140"
        align="center"
      ></el-table-column>
      <!-- <el-table-column
        prop="uname"
        label="操作"
        width="100"
        align="center"
      >
         <template slot-scope="scope">
          <div class="table_control">
            <span
              class="table_control_item"
              @click="
                toLearningManagement(
                  '1',
                  scope.row.examsPaperId,
                  scope.row.courseName,
                )
              "
              >巡考</span
            >
          </div>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import * as api from '@/api/ExamManagement/ComprehensiveTestDetail/examArrangement'
export default {
  data() {
    return {
      form: {
        fullName: '',
        userCard: '',

      },


      batchId: this.$route.query.batchId,
      uid: localStorage.getItem('uid') ,
      tableData: [],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      selectedList: [],
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
        if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      if (window.location.host == 'fxl.sce.scut.edu.cn') {
        url = url + '/zk'
      }
      return url
    },
  },
  created() {
    this.getStudentPageList()
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.enterQuery)
  },
  methods: {
    // 时间处理
    datetimeFormat(val) {
      if (!val) {
        return ''
      }
      const dt = new Date(val)
      const y = dt.getFullYear()
      const m = (dt.getMonth() + 1 + '').padStart(2, '0')
      const d = (dt.getDate() + '').padStart(2, '0')

      const hh = (dt.getHours() + '').padStart(2, '0')
      const mm = (dt.getMinutes() + '').padStart(2, '0')
      const ss = (dt.getSeconds() + '').padStart(2, '0')
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
    },
    async getStudentPageList() {
      const { data, code } = (
        await api.getStudentPageList({
          batchId: this.$route.query.batchId,
          teacherCourseBatchId:this.$route.query.teacherCourseBatchId,
          uid: localStorage.getItem('uid') ,
          ...this.form,
          ...this.pageObj,
        })
      ).data
      console.log(data);
      if (code === 100000) {
        this.tableData = data.list
        console.log();
        this.tableData.forEach(v =>{
          v.openTime = this.datetimeFormat(v.openTime)
          v.endTime = this.datetimeFormat(v.endTime)
          // "tourStatus": 巡考状态【0:未巡考 1:已通过 2:未通过】,
          if(v.tourStatus == "0"){
            v.tourStatus = "未巡考"
          }else if(v.tourStatus == "1"){
            v.tourStatus = "已通过"
          }else{
            v.tourStatus = "未通过"
          }
          // "scoreStatus": 巡考结果【0:待审核 1:成绩有效 2:成绩无效】
           if(v.scoreStatus == "0"){
            v.scoreStatus = "待审核"
          }else if(v.scoreStatus == "1"){
            v.scoreStatus = "成绩有效"
          }else{
            v.scoreStatus = "成绩无效"
          }
        })
        this.total = data.total
      }
    },
    //搜索
    search() {
      this.pageObj.page = 1;
      this.getStudentPageList();
      this.isSeach = true;
    },
    //清空搜索内容
    delAll() {
      this.form.fullName="",
      this.form.userCard="",
      this.pageObj.page = 1
      this.getStudentPageList()
    },

    enterQuery(e) {
      if (e.key === 'Enter') {
        this.getStudentPageList()
      }
    },

   toLearningManagement(tab, examsPaperId,  courseName) {
     this.$router.push(
        `/InvigilateDetails?tab=${tab}&exams_users_id=${examsPaperId}&examinerId=${this.uid}`
      )
  },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getStudentPageList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getStudentPageList()
    },
   
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },
    // goLearningOutcome() {
    //   this.$emit('goLearningOutcomeFromStudent')
    // },
    sortChange({ column, prop, order }) {},
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/classManagement.scss';
.table_control {
  color: #409eff;
  .table_control_item {
    cursor: pointer;
  }
}
</style>
